import React, { memo, ReactElement, RefObject } from 'react';

import ChatConversation, { ChatConversationMessage } from '@/components/chatConversation/chatConversation';

type Props = {
  id: string;
  input: string;
  isWaiting: boolean;
  messages: ChatConversationMessage[];
  enableStructured: boolean;
  messagesEndRef: RefObject<HTMLDivElement | null>;
  onClickChat: ( mode: string ) => void;
  onClickStop: () => void;
  onInputChange: ( value: string ) => void;
};

const PlaygroundChat = memo( ( {
  id,
  input,
  isWaiting,
  enableStructured,
  messages,
  messagesEndRef,
  onClickChat,
  onClickStop,
  onInputChange
}: Props ): ReactElement => {
  return (
    <ChatConversation
      id={ id }
      input={ input }
      isWaiting={ isWaiting }
      messages={ messages }
      messagesEndRef={ messagesEndRef }
      enableStructured = { enableStructured }
      onClickChat={ onClickChat }
      onClickStop={ onClickStop }
      onInputChange={ onInputChange }
    />
  );
} );

PlaygroundChat.displayName = 'PlaygroundChat';

export default PlaygroundChat;